<template>
  <div class="side-user-form">
    <div class="top-bar up-top-bar">
      <div class="up-top-links">
        <div class="up-top-link" v-if="user && user.active">
          <a @click="toggleUserActive">
            <img src=".././assets/images/deactivate_white.svg" alt="">&nbsp; Deactivate
          </a>
        </div>
        <div class="up-top-link" v-else>
          <a @click="toggleUserActive">
            <img src=".././assets/images/activate_white.svg" alt="">&nbsp; Activate
          </a>
        </div>

        <div class="up-top-link">
          <a @click="deleteUser">
            <img src=".././assets/images/trash_white.svg" alt="">&nbsp; Delete
          </a>
        </div>
        <div class="up-top-link ml-auto">
          <a @click="$emit('close')" style="color: #ebd470 !important;">Cancel</a>
        </div>
        <div class="up-top-link ml-auto">
          <a @click="updateUser">Save</a>
        </div>
      </div>
    </div>
    <div class="top-bar-menu">
      <router-link :to="`/attendance/tracking?user_id=${user.id}`">Attendance</router-link>
      <router-link :to="`/events?user_id=${user.id}`">Events</router-link>
    </div>
    <profile-component :user="user" page="UserProfile" @update="updatePhoto"></profile-component>
  </div>
</template>

<script>
  import ProfileComponent from '@/components/ProfileComponent';

  export default {
    name: 'StudentProfile',
    components: {
      ProfileComponent
    },
    props: {
      user: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        photo: null,
      };
    },
    beforeMount() {
      this.getUser();
    },
    methods: {
      redirectBack() {
        history.go(-1);
      },
      getUser() {
        this.$store.dispatch('users/loadUser', { user_id: this.user.id });
      },
      toggleUserActive() {
        let confirmationMessage = 'Are you sure you want to activate item?';

        if (this.user && this.user.active == 1) {
          confirmationMessage = 'Are you sure you want to deactivate item?';
        }

        if (confirm(confirmationMessage)) {
          this.user.active = !this.user.active;

          const data = {
            user_id: this.user.id,
            fields: ["active"],
            values: [this.user.active]
          };

          this.$store.dispatch('users/updateUser', data);
          this.getUser();
        }
      },
      deleteUser() {
        if (confirm('Are you sure you want to delete user?')) {
          this.$store.dispatch('users/deleteUser', { user_id: this.user.id })
            .then(() => {
              this.$snotify.success('User successfully deleted');
              this.$emit('close');
            })
            .catch(error => this.$snotify.error(error.response.data.message));
        }
      },
      updateUser() {
        const data = {
          user_id: this.user.id,
          fields: ["first_name", "last_name", "mail", "active", "type"],
          values: [this.user.first_name, this.user.last_name, this.user.mail, this.user.active, this.user.type]
        };

        this.$store.dispatch('users/updateUser', data)
          .then(() => {
            this.$snotify.success("User updated");
            this.updatePassword();
            this.updateUserPhoto();

            if (!this.photo && !this.user.key) {
              this.$emit('saved');
            }
          })
          .catch(error => this.$snotify.error(error.response.data.message));
      },
      updatePassword() {
        if (this.user.key) {
          const data = {
            auth_method: 0,
            new_key: this.user.key,
            user_id: this.user.id,
          };

          this.$store.dispatch('users/updatePassword', data)
            .then(() => {
              if (!this.photo) {
                this.$emit('saved');
              }
            });
        }
      },
      updatePhoto(photo) {
        this.photo = photo;
      },
      updateUserPhoto() {
        if (this.photo) {
          this.$store.dispatch('users/updatePhoto', { user_id: this.user.id, photo: this.photo })
          .then(() => this.$emit('saved'))
          .catch(error => this.$snotify.error(error.response.data.error));
        }
      }
    },
  };
</script>
